import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom'
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Grid, Typography, Input, Button, duration } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Skeleton from '@material-ui/lab/Skeleton';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Box from '@material-ui/core/Box';
import Rating from '@material-ui/lab/Rating';
import { red } from '@material-ui/core/colors';
import ShareIcon from '@material-ui/icons/Share';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import YouTubeIcon from '@material-ui/icons/YouTube';
import QueueMusicIcon from '@material-ui/icons/QueueMusic';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import * as SpotifyWebApi from 'spotify-web-api-js';
import { ethers } from "ethers";
import Web3 from 'web3';
// Vimeo Player only... see Vimeo2 for api client
import Vimeo from '@vimeo/player'
import SpotifyContainer from '../Spotify';
import YouTubeContainer from '../YouTube'
import VimeoContainer from '../Vimeo'
import YoutubeSearch from "youtube-api-search-reloaded";

require('dotenv').config()

let web3
web3 = new Web3(Web3.givenProvider);

let userAccount;
web3.eth.getAccounts((error, accounts) => {
    console.log(accounts);
    userAccount = accounts[0]
    console.log(userAccount)
});
//let provider = new ethers.getDefaultProvider('ropsten')
const provider = new ethers.providers.Web3Provider(window.ethereum);

// There is only ever up to one account in MetaMask exposed
const signer = provider.getSigner();
console.log(signer)

// let address = '0xA4ca1b15fE81F57cb2d3f686c7B13309906cd37B'
// provider.getTransactionCount(address).then((transactionCount) => {
//     console.log("Total Transactions Ever Sent: " + transactionCount);
// });

// provider.getBlockNumber().then((blockNumber) => {
//     console.log("Current block number: " + blockNumber);
// });

// provider.getGasPrice().then((gasPrice) => {
//     // gasPrice is a BigNumber; convert it to a decimal string
//     let gasPriceString = gasPrice.toString();

//     console.log("Current gas price: " + gasPriceString);
// });

// let ethereum = window.ethereum;
// window.addEventListener('load', async () => {
//     try { await ethereum.enable(); } catch (error) {}
// });


const RCT_ADDRESS = '0x9fdf34Ae804bA0aB98A410FDF5dc85FF02A0e437';
const RCT_ABI = [
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "_owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "_spender",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "_value",
				"type": "uint256"
			}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "approve",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "subtractedValue",
				"type": "uint256"
			}
		],
		"name": "decreaseAllowance",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "addedValue",
				"type": "uint256"
			}
		],
		"name": "increaseAllowance",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "_amount",
				"type": "uint256"
			}
		],
		"name": "sendTokensToPartner",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_streamOwner",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "_amount",
				"type": "uint256"
			}
		],
		"name": "sendTokensToStreamer",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "transfer",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "_from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "_to",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "_value",
				"type": "uint256"
			}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "sender",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "recipient",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "amount",
				"type": "uint256"
			}
		],
		"name": "transferFrom",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "addressBalanceTracker",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			}
		],
		"name": "allowance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"name": "allowanceTracker",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "balanceOf",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "decimals",
		"outputs": [
			{
				"internalType": "uint8",
				"name": "",
				"type": "uint8"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "name",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "standard",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "symbol",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];
//const RCT_CONTRACT =
const key = '0x34F25DD9CCBA9EF55E296BD0139C7CA75CDC8AA3E9DC8758D082C204AB5BC3A6';//process.env.REACT_APP_PRIVATE_KEY;// 
const wallet = new ethers.Wallet(key, provider);
const contract = new ethers.Contract(RCT_ADDRESS, RCT_ABI, wallet)
var decimalPlaces = 18;
let amount// = ethers.utils.parseUnits('0.666', decimalPlaces);




const useStyles = makeStyles((theme) => ({
    root: {
		flexGrow: 1,
		padding: 0
	},
	videoTile: {
		width: '100%',
		padding: 0
	},
    paper: {
        padding: 0,
        textAlign: 'center',
        color: '#fd5d93',//theme.palette.text.secondary,
        backgroundColor: '#6c757d',
	},
	grid: {
		padding: '5px'
	}
}));

// returns a GridRow of 3 videos
// Video data must be passed
function GridRowVideo({videos}) {
    const classes = useStyles();
    return (
      <React.Fragment>
            <Grid item xs={4}>
                <Paper className={classes.paper}>

                </Paper>
            </Grid>
            <Grid item xs={4}>
                <Paper className={classes.paper}>

                </Paper>
            </Grid>
            <Grid item xs={4}>
                <Paper className={classes.paper}>

                </Paper>
            </Grid>
      </React.Fragment>
    );
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
	  <div
		role="tabpanel"
		hidden={value !== index}
		id={`scrollable-force-tabpanel-${index}`}
		aria-labelledby={`scrollable-force-tab-${index}`}
		{...other}
	  >
		{value === index && (
		  <Box p={3}>
			<Typography>{children}</Typography>
		  </Box>
		)}
	  </div>
	);
}

  TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

  function a11yProps(index) {
	return {
	  id: `scrollable-force-tab-${index}`,
	  'aria-controls': `scrollable-force-tabpanel-${index}`,
	};
}

function ScrollableTabsButtonForce() {
	const classes = useStyles();

	const [tabValue, setTabValue] = useState(0);
	const [searchQuery, setSearchQuery] = useState('');
	const [videos, setVideos] = useState([]);
	const [content, setContent] = useState('')

	// Sets the search query value in state
	const handleQueryChange = (event) => {
        setSearchQuery(searchQuery => searchQuery = event.target.value)
        console.log(searchQuery)
	}

	const handleTabChange = (event, newValue) => {
	  	setTabValue(newValue);
	};

	// Search for videos
	const searchVideos = (query) => {
		console.log(query)
	};

	const authorizeVimeo = async () => {
		console.info('Vimeo Auth Clicked')
		//let uri = '/oauth/authorize?response_type=code&client_id=3f0a6f4f0f69e2077932628ad51db0a4370be2d8&redirect_uri=https://rawcipher.com&state=n8y90b3t'
		// using proxy for cors
		let uri = 'https://rcn-proxy-server.herokuapp.com/https://api.vimeo.com/oauth/authorize?response_type=code&client_id=3f0a6f4f0f69e2077932628ad51db0a4370be2d8&redirect_uri=https://rawcipher.com';
		//'https://api.vimeo.com/oauth/authorize'
		let body = {
			"grant_type": "authorization_code",
			"code": "{code}",
			"redirect_uri": "https://rawcipher.com"
		}

		const rawResponse = fetch(uri, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body)
		}).then((res, err) => {
			if (err) {
				console.error(err)
			} else {
				console.info(res)
				setContent(res.text());
				console.log(content)
			}
		})
	}

	// get a list of videos to display
	const getVideos = async () => {

	}

	const updateVideos = async () => {
		getVideos();
	}


	return (
	  <React.Fragment>
		<AppBar position="sticky" color="transparent">
		  <Tabs
			value={tabValue}
			onChange={handleTabChange}
			variant="scrollable"
			scrollButtons="on"
			indicatorColor="secondary"
			textColor="secondary"
			aria-label="navigation tabs"
		  >
			<Tab label="YouTube" icon={<YouTubeIcon />} {...a11yProps(0)} style={{ color: 'yellow' }}/>
			<Tab label="Vimeo" icon={<VideoLibraryIcon />} {...a11yProps(1)}  style={{ color: 'yellow' }}/>			
			<Tab label="Spotify" icon={<QueueMusicIcon />} {...a11yProps(2)}  style={{ color: 'yellow' }}/>
			{/* <Tab label="Artlist" icon={<LibraryMusicIcon />} {...a11yProps(3)} />
			<Tab label="Item Five" icon={<ShoppingBasket />} {...a11yProps(4)} />
			<Tab label="Item Six" icon={<ThumbDown />} {...a11yProps(5)} />
			<Tab label="Item Seven" icon={<ThumbUp />} {...a11yProps(6)} /> */}
		  </Tabs>
		</AppBar>
		<TabPanel value={tabValue} index={1}>
		<Typography style={{ color: '#2c91c7' }}> Just press play and see the rate of RCT. It is based on duration and popularity.</Typography>
           {/* <Button variant='contained' color='secondary' onClick={authorizeVimeo}>Authorize Vimeo</Button> */}
			<br /><br />

            <Grid container spacing={1} className={classes.grid}>
                <Grid container item xs={12} lg={12} spacing={1}>
                    <Grid item xs={12}>
                        <Paper className={classes.paper}>
						<Input
							onChange={handleQueryChange}
							id='artist'
							color='secondary'
							type='text'
							placeholder='video search'
						/>
                            <Button
                                variant='contained'
								onClick={() => { searchVideos(searchQuery) }}
							>Search</Button>
                        </Paper>
                    </Grid>
                </Grid>
                {/* Group 1 */}
                <Grid container item xs={12} md={12} lg={12} spacing={1}>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-1'} source='https://player.vimeo.com/video/160335390' />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-2'} source='https://player.vimeo.com/video/237349572' />
                        </Paper>
                    </Grid>
                    <Grid  item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-3'} source='https://player.vimeo.com/video/236584808' />
                        </Paper>
                    </Grid>
                </Grid>
				 {/* Group 2 */}
                <Grid container item xs={12} spacing={1}>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-4'} source='https://player.vimeo.com/video/429924982' />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-5'} source='https://player.vimeo.com/video/2371306' />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-6'} source='https://player.vimeo.com/video/396807064' />
                        </Paper>
                    </Grid>
                </Grid>
				 {/* Group 3 */}
				 <Grid container item xs={12} spacing={1}>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-7'} source='https://player.vimeo.com/video/282586471' />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-8'} source='https://player.vimeo.com/video/282586060' />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                        <Paper className={classes.paper}>
                            <VideoTile theKey={'video-9'} source='https://player.vimeo.com/video/273586165' />
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>

		</TabPanel>
		<TabPanel value={tabValue} index={0}>
			<YouTubeContainer />
		</TabPanel>
		<TabPanel value={tabValue} index={2}>
		   <SpotifyContainer />
		</TabPanel>
		<TabPanel value={tabValue} index={3}>
			<Grid container spacing={1}>
				<Grid item xs={12} md={4} lg={4}>

				</Grid>
				<Grid item xs={12} md={4} lg={4}>

				</Grid>
				<Grid item xs={12} md={4} lg={4}>

				</Grid>
			</Grid>
		</TabPanel>
	  </React.Fragment>
	);
}

const VideoTile = ({source, theKey}) => {
    const classes = useStyles();
	const [rating1, setRating1] = useState(4)
	const [rating2, setRating2] = useState(4)
	const [rating3, setRating3] = useState(4)
	const [rating4, setRating4] = useState(4)
	const [rating5, setRating5] = useState(4)
	const [rating6, setRating6] = useState(4)
	const [ratings, setratings] = useState([])
	const [rate, setRate] = useState(0)
	const [duration, setDuration] = useState(0)
	const [title, setTitle] = useState('')
	const movieTileRef = useRef();
	const iframeRef = useRef();
	console.info(movieTileRef)

	useEffect(() => {
		console.log('use effect lifecycle | video tile: component did mount')
		return () => {

		}
	}, [])

	useLayoutEffect(() => {
		console.log('use layout effect lifecycle | video tile: component did mount');

		// The payment funciton will execute when video ends completely
		const payTheMan = (amount) => {
			let sendPromise = contract.sendTokensToStreamer(userAccount, ethers.utils.parseUnits(amount.toFixed(18), decimalPlaces));
			sendPromise.then((tx) => {
				console.log(tx)
			});
			console.log(`Payout executed!`)
		}

		var iframe = document.getElementById(theKey);
		var player = new Vimeo(iframe);

		player.on('play', function(videoStats) {
			if(videoStats.duration != undefined){
				setRate(rate => videoStats.duration * .00325);
				setDuration(videoStats.duration);
			}

			console.log(`Duration in seconds: ${videoStats.duration}`)
		})

		// Fire the payment function on end
		player.on('ended', function(videoStats) {
			console.log('you have been paid for watching!', videoStats);
			if(videoStats.seconds === videoStats.duration) {
				// todo: need to make sure they didn't already get paid for the video?? Or do we really care?
				// todo: can run an ad if replay?

				// Set the rate of payment and pass to payTheMan
				payTheMan(videoStats.duration * .00325);
				alert('Your payment has been sent!')
			}
		});

		// Stop the user from fast forwarding to the end for payment
		player.on('seeked', (videoStats) => {
			player.setCurrentTime(0);
		});

		player.getVideoTitle().then(function(title) {
			setTitle(title);
			console.log('title:', title);
		});

		return () => {

		};
	}, [])

    return (
        <div className={classes.videoTile}>
             <Typography>Title: {title} | Value: {rate.toFixed(4)} RCT</Typography>
			 <Typography>Watch to get paid | Duration: {duration}</Typography>
			<iframe
				ref={movieTileRef}
				id={theKey}
				src={source}
				title={title}
				frameBorder="0"
				webkitallowfullscreen='true'
				mozallowfullscreen='true'
				allowFullScreen
				width="250"
				height="200"
			></iframe><br />
            <Rating
				key={theKey}
				name="simple-controlled"
				value={rating1}
				onChange={(event, newValue) => {
					setRating1(newValue);
				}}
            />
        </div>
    )
}







/**
 * 	@dev Marketplace View
 */
const Marketplace = () => {
	const classes = useStyles();

    return (
        <div className={classes.root} style={{ padding: '15px', margin: '10px' }}>
			<ScrollableTabsButtonForce />
        </div>
    )
}

export default Marketplace;